function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6998 10.8L10.6999 9.00017C10.7 8.006 9.89409 7.20001 8.89992 7.20001H4.10028C3.10625 7.20001 2.30039 8.00578 2.30028 8.99981L2.30008 10.8M8.30008 3.00001C8.30008 3.99412 7.49419 4.80001 6.50008 4.80001C5.50597 4.80001 4.70008 3.99412 4.70008 3.00001C4.70008 2.0059 5.50597 1.20001 6.50008 1.20001C7.49419 1.20001 8.30008 2.0059 8.30008 3.00001Z",
    stroke: "#8B8A9E",
    style: {
      stroke: "#8B8A9E",
      stroke: "color(display-p3 0.5451 0.5412 0.6196)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.95926acf8b15f553d353165c8c129959.svg";
export { ForwardRef as ReactComponent };